import { createSelector } from 'reselect';

import { getFilters } from '../filters';
import { getDeveloper } from '../developerV2';

export const moscowCoords = { lat: 55.755814, lng: 37.617635 };
export const moscowZoom = 10;

const defaultCoords = { center: moscowCoords, zoom: moscowZoom };

export const getRegionCenterCoordinates = createSelector([getFilters, getDeveloper], (filters, developer) => {
  const region = developer.regions.find(region => region.id === filters.regionId);

  if (!region) {
    return defaultCoords;
  }

  const coordinates = region.centerCoordinates;

  const center = { lat: coordinates.lat, lng: coordinates.lng };

  if (!coordinates.zoom) {
    return { center, zoom: moscowZoom };
  }

  return { center: { lat: coordinates.lat, lng: coordinates.lng }, zoom: coordinates.zoom };
});
